import { render, staticRenderFns } from "./MeterUserinfoTransferRecordList.vue?vue&type=template&id=5389fa3e&scoped=true"
import script from "./MeterUserinfoTransferRecordList.vue?vue&type=script&lang=js"
export * from "./MeterUserinfoTransferRecordList.vue?vue&type=script&lang=js"
import style0 from "./MeterUserinfoTransferRecordList.vue?vue&type=style&index=0&id=5389fa3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389fa3e",
  null
  
)

export default component.exports